module.exports = __webpack_public_path__ + "static/media/13_4.2a722d60.jpg";